import React from 'react';

import styles from './AppError.module.css';

interface Props {
  title: string;
}

const AppErrorTitle = ({ title }: Props) => {
  return <h1 className={ styles.title }>{ title }</h1>;
};

export default AppErrorTitle;
